'use strict';

var app = require('mag-app'),
    storage = window.top.localStorage || window.top.stbStorage,
    accounts = storage.getItem('accounts');


if ( accounts ) {
    try {
        accounts = JSON.parse(accounts);
    } catch ( exception ) {
        accounts = [];
    }
} else {
    accounts = [];
}

if ( app.query.server ) {
    // credentials in GET params
    accounts = [
        {
            login: app.query.login,
            password: app.query.password,
            address: app.query.server,
            activationCode: app.query.activationCode,
            latest: true
        }
    ];
}

module.exports = {
    get: function () {
        return accounts;
    },
    add: function ( account ) {
        accounts.forEach(function ( item ) {
            item.latest = false;
        });
        account.latest = true;
        accounts.push(account);
        storage.setItem('accounts', JSON.stringify(accounts));
    },
    update: function ( account, index ) {
        if ( accounts[index] ) {
            accounts[index] = account;
        }
        accounts.forEach(function ( item ) {
            item.latest = false;
        });
        account.latest = true;
        storage.setItem('accounts', JSON.stringify(accounts));
    },
    remove: function ( account ) {
        var index = accounts.indexOf(account);

        if ( index === -1 ) {
            account = JSON.stringify(account);
            index = 0;
            while ( index < accounts.length ) {
                if ( JSON.stringify(accounts[index]) === account ) {
                    accounts.splice(index, 1);
                    break;
                }
                ++index;
            }
        } else {
            accounts.splice(accounts.indexOf(account), 1);
        }
        storage.setItem('accounts', JSON.stringify(accounts));
    }
};
